import { useNavigate, Link } from "react-router-dom";
import useLogout from "../../hooks/useLogout";

const Home = () => {
    const navigate = useNavigate();
    const logout = useLogout();

    const signOut = async () => {
        await logout();
        navigate('/linkpage');
    }

    return (
        <div className="fade-in" style={{ maxWidth: "1000px", margin: "0 auto", padding: "2rem 1rem" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "3rem" }}>
                <h1
                    style={{
                        fontSize: "2.5rem",
                        fontWeight: "700",
                        background: "linear-gradient(135deg, var(--primary-purple-light), var(--accent-cyan))",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                    }}
                >
                    Welcome Back
                </h1>
                <button className="btn-secondary" onClick={signOut}>
                    Sign Out
                </button>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "2rem" }}>
                <div className="card" style={{ padding: "2rem", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <div style={{ fontSize: "3rem", marginBottom: "1rem", background: "rgba(124, 58, 237, 0.1)", padding: "1rem", borderRadius: "12px" }}>📊</div>
                    <h2 style={{ fontSize: "1.5rem", fontWeight: "600", marginBottom: "0.5rem" }}>Manager Dashboard</h2>
                    <p style={{ color: "var(--text-muted)", marginBottom: "1.5rem", flex: 1 }}>
                        Create and manage quizzes, view results, and handle participants.
                    </p>
                    <button className="btn-primary" onClick={() => navigate("/manager")}>
                        Go to Dashboard
                    </button>
                </div>

                <div className="card" style={{ padding: "2rem", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <div style={{ fontSize: "3rem", marginBottom: "1rem", background: "rgba(6, 182, 212, 0.1)", padding: "1rem", borderRadius: "12px" }}>⚙️</div>
                    <h2 style={{ fontSize: "1.5rem", fontWeight: "600", marginBottom: "0.5rem" }}>Admin Portal</h2>
                    <p style={{ color: "var(--text-muted)", marginBottom: "1.5rem", flex: 1 }}>
                        Manage system users, assign credits, and oversee platform usage.
                    </p>
                    <button className="btn-secondary" onClick={() => navigate("/admin")}>
                        Go to Admin
                    </button>
                </div>

                <div className="card" style={{ padding: "2rem", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <div style={{ fontSize: "3rem", marginBottom: "1rem", background: "rgba(245, 158, 11, 0.1)", padding: "1rem", borderRadius: "12px" }}>🔗</div>
                    <h2 style={{ fontSize: "1.5rem", fontWeight: "600", marginBottom: "0.5rem" }}>Quick Links</h2>
                    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", width: "100%" }}>
                        <Link to="/linkpage" style={{ color: "var(--accent-cyan)", textDecoration: "none" }}>→ Public Landing Page</Link>
                        <Link to="/lounge" style={{ color: "var(--accent-cyan)", textDecoration: "none" }}>→ Lounge (Test)</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home
